import React from "react";
import Loader from "react-loader-spinner";

export default ({
  width,
  height,
  color = "#00BFFF",
  type = "TailSpin",
  loaderClass,
  loaderStyle,
}) => {
  return (
    <div>
      <span>
        <Loader
          style={loaderStyle}
          className={loaderClass}
          type={type}
          color={color}
          height={height}
          width={width}
        />
      </span>
    </div>
  );
};
